import React, { useCallback } from 'react';

import { useCreateCompetition } from '@pkg/hooks';

import { type CreateCompetition } from '@app/client';

import { GameForm } from '../GameForm';

export const useHandleCreateCompetition = (onSuccess?: (slug: string) => void) => {
    const { mutateAsync, isLoading } = useCreateCompetition();

    return useCallback(
        (gameData: CreateCompetition) => {
            if (isLoading) return;
            mutateAsync(gameData).then(async (res) => {
                if (!res.ok) {
                    alert(res.error);
                }
                if (res && res.ok) {
                    onSuccess?.(res.value.slug);
                }
            });
        },
        [isLoading, mutateAsync, onSuccess],
    );
};

interface CreateGameProps {
    onSuccess?: (slug: string) => void;
}

export const CreateGame = ({ onSuccess }: CreateGameProps) => {
    const createCompetition = useHandleCreateCompetition(onSuccess);
    return <GameForm onCreate={createCompetition} />;
};
